export default __webpack_public_path__ + "static/Bahrainblack-310b3550fba49c32bc561a21c219f1f7.webp";